<div class="fn__container is-fullbleed is-adjacent is-footer" *ngIf="footerData" aria-label="Footer">
  <div class="fn__container__col">
    <footer class="fn__footer" style="display: block">
      <nav class="fn__footer__nav" aria-label="Footer">
        <ul class="fn__footer__nav-group fn__footer__nav-group--links">
          <li class="fn__footer__nav-column">
            <h2 class="fn__footer__nav-header" aria-level="2">
              <a
                [href]="firstColumn.headerLink.url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="firstColumn.headerLink.text"
                >{{ firstColumn.headerLink.text }}</a
              >
            </h2>
            <ul class="fn__footer__nav-list" *ngIf="firstColumn.links.length > 0" aria-label="First Column Links">
              <li class="fn__footer__nav-item inactive" *ngFor="let subLink of firstColumn.links">
                <a
                  class="fn__footer__nav-link"
                  role="link"
                  rel="noopener noreferrer"
                  [href]="subLink.url"
                  target="_blank"
                  [attr.aria-label]="'Go to ' + subLink.text"
                  >{{ subLink.text }}</a
                >
              </li>
            </ul>
          </li>
          <li class="fn__footer__nav-column" *ngIf="secondColumn">
            <h2 class="fn__footer__nav-header" aria-level="2">
              <a
                [href]="secondColumn.headerLink.url"
                role="link"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="secondColumn.headerLink.text"
              >
                {{ secondColumn.headerLink.text }}
              </a>
            </h2>
            <ul class="fn__footer__nav-list" aria-label="Second Column Links">
              <li class="fn__footer__nav-item inactive" *ngFor="let subLink of secondColumn.links">
                <a
                  role="link"
                  class="fn__footer__nav-link"
                  rel="noopener noreferrer"
                  [href]="subLink.url"
                  target="_blank"
                  [attr.aria-label]="'Go to ' + subLink.text"
                >
                  {{ subLink.text }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="fn__footer__nav-group fn__footer__nav-group--quicklinks" aria-label="Quick Links">
          <li class="fn__footer__nav-quickitem" *ngIf="callToActionColumn">
            <a
              class="btn--cta link link--arrow fn__footer__nav-quicklink"
              *ngFor="let callAction of callToActionColumn.links"
              rel="noopener noreferrer"
              role="link"
              [href]="callAction.url"
              target="_blank"
              [attr.aria-label]="'Call to action: ' + callAction.text"
              >{{ callAction.text }}</a
            >
          </li>
        </ul>
        <ul class="fn__footer__nav-group fn__footer__nav-group--cuna" aria-label="CUNA Links">
          <li class="fn__footer__cuna-item fn__footer__cuna-item--logo">
            <a
              [href]="thirdColumn.headerLink"
              aria-label="TruStage Annuities homepage"
              rel="noopener noreferrer"
              role="link"
              title="TruStage Annuities homepage"
              target="_blank"
            >
              <img
                src="https://static.trustage.com/brand/assets/images/trustage-logo.svg"
                alt="TruStage Logo"
                class="initial loaded"
                data-was-processed="true"
              />
            </a>
          </li>
          <li class="fn__footer__cuna-item fn__footer__social-items">
            <a
              class="social"
              *ngFor="let socialLink of socialLinks"
              [href]="socialLink.url"
              [title]="'Find us on ' + socialLink.text"
              target="{{ socialLink.target }}"
              [attr.aria-label]="'Find us on ' + socialLink.text"
            >
              <img
                data-src="{{ socialLink.imgUrl }}"
                [alt]="socialLink.text + ' logo'"
                class="loading"
                data-was-processed="true"
              />
            </a>
          </li>
          <li class="fn__footer__cuna-item" *ngFor="let legalLink of thirdColumn">
            <a
              class="fn__footer__cuna-link"
              [href]="legalLink.url"
              target="_blank"
              role="link"
              rel="noopener noreferrer"
              [attr.aria-label]="legalLink.text"
              >{{ legalLink.text }}</a
            >
          </li>
          <li class="fn__footer__cuna-item fn__footer__cuna-item--copyright" aria-label="Copyright Information">
            © 2025 TruStage, all rights reserved
          </li>
        </ul>
      </nav>

      <div
        class="fn__footer__disclaimer"
        [innerHTML]="contentSanitizedHtml(disclosureText)"
        aria-label="Disclaimer"
      ></div>

      <div class="fn__footer__complianceid" aria-label="Compliance ID">{{ complianceId }}</div>
    </footer>
  </div>
</div>
